import { FormulaireContactB2b } from '@components/formulaire-contact-b2b/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

const phone = '+33612345678';
const email = 'hhornain@socooc.com';
const linkedinUrl = 'https://www.linkedin.com/in/sundarpichai/';
const picture = imageMock;

export const formulaireContactB2bMock: Block<FormulaireContactB2b> = {
  type: 'formulaire-contact-b2b',
  data: {
    questionSection: {
      firstQuestion: {
        text: "Pourquoi êtes-vous intéressé par la franchise SoCoo'c ?",
        options: [
          {
            text: 'Je souhaite réaliser un investissement financier',
            picto: {
              svg: '/assets/tmp/store.svg',
            },
          },
          {
            text: "J'ai la fibre entrepreneuriale",
            picto: {
              svg: '/assets/tmp/store.svg',
            },
          },
          {
            text: "J'ai eu des échos positifs sur la franchise",
            picto: {
              svg: '/assets/tmp/store.svg',
            },
          },
          {
            text: 'Autre',
            picto: {
              svg: '/assets/tmp/store.svg',
            },
          },
        ],
      },
      secondQuestion: {
        text: 'Décrivez-vous en 3 hashtags :',
        subtext: 'Facultatifs',
      },
    },
    formSection: {
      title: 'Dîtes-nous en plus',
      legalNotice: `Pour connaître l'utilisation que nous faisons des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en matière d'accès et de suppression, veuillez consulter notre <a href="/mock-confidentialite">charte de confidentialité.</a>`,
      developers: [
        {
          name: 'Raoul',
          area: [
            '02 - Aisne',
            '08 - Ardennes',
            '10 - Aube',
            "21 - Côte-d'Or",
            '25 - Doubs',
            '39 - Jura',
            '51 - Marne',
            '52 - Haute-Marne',
            '54 - Meurthe-et-Moselle',
            '55 - Meuse',
            '57 - Moselle',
            '58 - Nièvre',
            '59 - Nord',
            '60 - Oise',
            '62 - Pas-de-Calais',
            '67 - Bas-Rhin',
            '68 - Haut-Rhin',
            '70 - Haute-Saône',
            '71 - Saône-et-Loire',
            '88 - Vosges',
            '89 - Yonne',
            '90 - Territoire de Belfort',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
        {
          name: 'Jean',
          area: [
            '01 - Ain',
            '03 - Allier',
            '07 - Ardèche',
            '15 - Cantal',
            "21 - Côte-d'Or",
            '26 - Drôme',
            '38 - Isère',
            '42 - Loire',
            '43 - Haute-Loire',
            '58 - Nièvre',
            '63 - Puy-de-Dôme',
            '69 - Rhône',
            '71 - Saône-et-Loire',
            '73 - Savoie',
            '74 - Haute-Savoie',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
        {
          name: 'Paola',
          area: [
            '09 - Ariège',
            '11 - Aude',
            '12 - Aveyron',
            '30 - Gard',
            '31 - Haute-Garonne',
            '32 - Gers',
            '34 - Hérault',
            '46 - Lot',
            '48 - Lozère',
            '65 - Hautes-Pyrénées',
            '66 - Pyrénées-Orientales',
            '81 - Tarn',
            '82 - Tarn-et-Garonne',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
        {
          name: 'Michel',
          area: [
            '04 - Alpes-de-Haute-Provence',
            '05 - Hautes-Alpes',
            '06 - Alpes-Maritimes',
            '07 - Ardèche',
            '11 - Aude',
            '13 - Bouches-du-Rhône',
            '26 - Drôme',
            '2A - Corse-du-Sud',
            '2B - Haute-Corse',
            '30 - Gard',
            '34 - Hérault',
            '83 - Var',
            '84 - Vaucluse',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
        {
          name: 'Astrid',
          area: [
            '971 - Guadeloupe',
            '972 - Martinique',
            '973 - Guyane',
            '974 - La Réunion',
            '976 - Mayotte',
            '14 - Calvados',
            "22 - Côtes-d'Armor",
            '27 - Eure',
            '28 - Eure-et-Loir',
            '29 - Finistère',
            '35 - Ille-et-Vilaine',
            '44 - Loire-Atlantique',
            '50 - Manche',
            '53 - Mayenne',
            '56 - Morbihan',
            '61 - Orne',
            '72 - Sarthe',
            '76 - Seine-Maritime',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
        {
          name: 'Micheline',
          area: [
            '16 - Charente',
            '17 - Charente-Maritime',
            '19 - Corrèze',
            '23 - Creuse',
            '24 - Dordogne',
            '33 - Gironde',
            '36 - Indre',
            '37 - Indre-et-Loire',
            '40 - Landes',
            '41 - Loir-et-Cher',
            '45 - Loiret',
            '47 - Lot-et-Garonne',
            '49 - Maine-et-Loire',
            '64 - Pyrénées-Atlantiques',
            '79 - Deux-Sèvres',
            '85 - Vendée',
            '86 - Vienne',
            '87 - Haute-Vienne',
          ],
          email,
          linkedinUrl,
          phone,
          picture,
        },
      ],
      submitButton: {
        label: 'Envoyer',
        url: '/ouvrir-un-magasin/confirmation_envoi_formulaire_contact',
      },
    },
    appointmentSection: {
      title: 'Prenez rendez-vous',
      text: "Directement dans l'agenda de nos développeurs",
      cta: {
        label: 'Prendre rendez-vous',
        url: 'https://www.francetravail.fr/accueil/',
      },
    },
    gtmConfigBtnForm: {
      event: 'submit_cta_contact_franchise',
      group: 'contact',
      description: 'contact franchise',
      context: 'clic bouton validation formulaire',
    },
  },
};
